import IAction from "../store/IAction";
import * as IApplicationVmInstance from "../models/shared/IApplicationVm";
import InitState from "../store/initState";
import { Dispatch } from "redux";
import Api from "../services/api";
import * as citizenReducer from "./citizenReducer";
import { CertificateProcessType } from "../models/flags/CertificateProcessType";
import ICitizenVm from "../models/shared/ICitizenVm";
import { UserType } from "../models/flags/UserType";
import i18n from "../i18n/i18n";
import { FormerLicenseType } from "../models/enums/FormerLicenseType";
import { push } from "connected-react-router";
import { ExaminationResultType } from "../models/enums/ExaminationResultType";
import * as ICitizenVmInstance from "../models/shared/ICitizenVm";
import { CertificateType } from "../models/flags/CertificateType";
import * as invoiceReducers from "./invoiceReducer";
import * as IApplicationForTaxBasedOnExternalVmInstance from "../models/shared/IApplicationForTaxBasedOnExternalVm";
import IApplicationVm from "../models/shared/IApplicationVm";
import IApplicationForTaxRenewalVm from "../models/citizen/IApplicationForTaxRenewalVm";
import IApplicationForTaxReplacementBasedOnExternalVm from "../models/citizen/IApplicationForTaxReplacementBasedOnExternalVm";
import IApplicationForTaxChangeBasedOnExternalVm from "../models/citizen/IApplicationForTaxChangeBasedOnExternalVm";
import IApplicationForTaxIssuingVm from "../models/citizen/IApplicationForTaxIssuingVm";
import IApplicationForTaxChangeVm from "../models/citizen/IApplicationForTaxChangeVm";
import IApplicationForTaxRenewalBasedOnExternalVm from "../models/citizen/IApplicationForTaxRenewalBasedOnExternalVm";
import IApplicationForTaxCaseWorkerVm from "../models/issuingAuthority/IApplicationForTaxCaseWorkerVm";
import * as metaReducer from "./metaReducer";
import { ApplicationCardStatusType } from "../models/enums/ApplicationCardStatusType";
import { ApplicationSubmitStatusType } from "../models/enums/ApplicationSubmitStatusType";
import { IApplicationSearchObject } from "../components/SearchApplications/SearchBox";
import IMunicipalityVm from "../models/shared/IMunicipalityVm";
import IEducationalInstitutionVm from "../models/shared/IEducationalInstitutionVm";
import ITeamVm from "../models/shared/ITeamVm";
import IApplicationBaseSearchVm from "../models/shared/IApplicationBaseSearchVm";
import { ApplicationStatusType } from "../models/enums/ApplicationStatusType";
import { EducationalCourseType } from "../models/enums/EducationalCourseType";
import { PaymentType } from "../models/enums/PaymentType";
import ICompanyVm from "../models/shared/ICompanyVm";
import * as driverLicenseReducer from "./driverLicenseReducer";
import applicationsForTaxBasedOnExternalReducer from "./applicationForTaxBasedOnExternalReducer";
import IApplicationForVubVm from "../models/shared/IApplicationForVubVm";
import IApplicationForCubVm from "../models/shared/IApplicationForCubVm";
import * as ICommentVmInstance from "../models/shared/ICommentVm";
import * as IEducationalInstitutionVmInstance from "../models/shared/IEducationalInstitutionVm";
import * as IIssuingAuthorityVm from "../models/issuingAuthority/IIssuingAuthorityVm";
import * as commentsReducer from "./commentsReducer";
import IUserVm from "../models/shared/IUserVm";
import { Guid } from "guid-typescript";
import { companyReducer } from "./companiesReducer";
import { MedicalCertificateStatusType } from "../models/enums/MedicalCertificateStatusType";
import UserHelper from "../services/userHelper";
import { ISortObject } from "./metaReducer";
import IApplicationForStaVm from "../models/shared/IApplicationForStaVm";
import * as IApplicationForStaVmInstance from "../models/shared/IApplicationForStaVm";
import criminalRecordDeclarationReducer from "./criminalRecordDeclarationReducer";
import IApplicationForTaxVm from "../models/shared/IApplicationForTaxVm";
import { ApplicabilityType } from "../models/flags/ApplicabilityType";
import IApplicationForAdrVm from "../models/shared/IApplicationForAdrVm";
import IApplicationForAdrIssuingVm from "../models/educationalInstitution/IApplicationForAdrIssuingVm";
import { AttendingSpecialCourseType } from "../models/enums/AttendingSpecialCourseType";

const ADD_APPLICATION = "BAT2/applications/ADD_APPLICATION";
const ADD_COMMENT = "BAT2/application/ADD_COMMENT";
const REMOVE_APPLICATION = "BAT2/applications/REMOVE_APPLICATION";
const REPLACE_APPLICATION = "BAT2/applications/REPLACE_APPLICATION";
const REPLACE_APPLICATIONS = "BAT2/applications/REPLACE_APPLICATIONS";
const REPLACE_CITIZEN = "BAT2/applications/REPLACE_CITIZEN";
const UPDATE_SELECTED_TEAM = "BAT2/applications/UPDATE_SELECTED_TEAM";
const UPDATE_APPLICATION_IS_NAME_CONFIRMED = "BAT2/application/UPDATE_APPLICATION_IS_NAME_CONFIRMED";
const UPDATE_CERTIFICATE_EXPIRE_TIME_SPAN_ID = "BAT2/application/UPDATE_CERTIFICATE_EXPIRE_TIME_SPAN_ID";
const UPDATE_CHOSEN_EDUCATIONAL_COURSE_TYPE = "BAT2/application/UPDATE_CHOSEN_EDUCATIONAL_COURSE_TYPE";
const UPDATE_CODE_OF_CONDUCT_STATUS = "BAT2/application/UPDATE_CODE_OF_CONDUCT_STATUS";
const UPDATE_COMPANY_CHOSEN_FOR_PAYMENT = "BAT2/application/UPDATE_COMPANY_CHOSEN_FOR_PAYMENT";
const UPDATE_CRIMINAL_ASSESSMENT_STATUS = "BAT2/application/UPDATE_CRIMINAL_ASSESSMENT_STATUS";
const UPDATE_EDUCATIONAL_INSTITUTION = "BAT2/application/UPDATE_EDUCATIONAL_INSTITUTION";
const UPDATE_EXAMINATION_RESULT_TYPE = "BAT2/application/UPDATE_EXAMINATION_RESULT_TYPE";
const UPDATE_EXAMINATION_RESULT_DATE = "BAT2/application/UPDATE_EXAMINATION_RESULT_DATE";
// const UPDATE_HAS_FOREIGN_CERTIFICATE_OR_EDUCATION = "BAT2/application/UPDATE_HAS_FOREIGN_CERTIFICATE_OR_EDUCATION"
const UPDATE_IS_STATEMENT_OF_CONSENT_CRIMINAL_RECORD_ACCEPTED = "BAT2/application/UPDATE_IS_STATEMENT_OF_CONSENT_CRIMINAL_RECORD_ACCEPTED";
const UPDATE_IS_STATEMENT_OF_CONSENT_MEDICAL_CERTIFICATE_ACCEPTED = "BAT2/application/UPDATE_IS_STATEMENT_OF_CONSENT_MEDICAL_CERTIFICATE_ACCEPTED";
const UPDATE_MEDICAL_CERTIFICATE_MARKED_AS_SENT = "BAT2/application/UPDATE_MEDICAL_CERTIFICATE_MARKED_AS_SENT";
const UPDATE_MEDICAL_CERTIFICATE_STATUS = "BAT2/application/UPDATE_MEDICAL_CERTIFICATE_STATUS";
const UPDATE_PROFILE_IMAGE = "BAT2/application/UPDATE_PROFILE_IMAGE";
const UPDATE_PROFILE_IMAGE_CARD_STATUS = "BAT2/application/UPDATE_PROFILE_IMAGE_CARD_STATUS";
const UPDATE_PROFILE_IMAGE_FOR_RESUBMIT = "BAT2/application/UPDATE_PROFILE_IMAGE_FOR_RESUBMIT";
const UPDATE_SELECTED_PAYMENT_TYPE = "BAT2/application/UPDATE_SELECTED_PAYMENT_TYPE";
const UPDATE_SIGNATURE_IMAGE = "BAT2/application/UPDATE_SIGNATURE_IMAGE";
const UPDATE_APPLICABILITY_TYPE = "BAT2/application/UPDATE_APPLICABILITY_TYPE";
const UPDATE_HAS_PREVIOUS_APPLICATION_DATE = "BAT2/application/UPDATE_HAS_PREVIOUS_APPLICATION_DATE";
const UPDATE_ATTENDING_SPECIAL_COURSE = "BAT2/application/UPDATE_ATTENDING_SPECIAL_COURSE";
const UPDATE_PREVIOUS_CERTIFICATE_EXPIRE_DATE = "BAT2/application/UPDATE_PREVIOUS_CERTIFICATE_EXPIRE_DATE";
const UPDATE_IS_CONTINUING_EDUCATIOAN_BASED_ON_NON_BAT_APPLICATION = "BAT2/application/UPDATE_IS_CONTINUING_EDUCATIOAN_BASED_ON_NON_BAT_APPLICATION";
const UPDATE_SPECIAL_CONDITION_MET = "BAT2/application/UPDATE_SPECIAL_CONDITION_MET";
const UPDATE_HEALTH_CONDITION_MET = "BAT2/application/UPDATE_HEALTH_CONDITION_MET";

export default function applicationsReducer(state: IApplicationVm[] = [], action: IAction): IApplicationVm[] {
  switch (action.type) {
    case ADD_APPLICATION:
      return [...state, action.payload];
    case REMOVE_APPLICATION:
      return [...state].filter((x) => x.id !== action.payload);
    case REPLACE_APPLICATION:
      return [...state].map((application) => {
        if (application.id !== (action.payload as IApplicationVm).id) {
          return application;
        }
        return {
          ...application,
          ...action.payload,
        };
      });
    case REPLACE_APPLICATIONS:
      return [...action.payload];
    default:
      if (state.length) {
        return [...state].map((app: IApplicationVm) => {
          return applicationReducer(app, action);
        });
      }
  }
  return state;
}

// Shared application reducer
function applicationReducer(state: IApplicationVm = new InitState().application, action: IAction): IApplicationVm {
  if (state === null || state === undefined) {
    return state;
  }
  if (state.id === action.id) {
    switch (action.type) {
      case REPLACE_CITIZEN:
        return { ...state, citizen: action.payload };
      case UPDATE_COMPANY_CHOSEN_FOR_PAYMENT:
        return { ...state, companyChosenForPayment: action.payload };
      case UPDATE_PROFILE_IMAGE:
        return { ...state, base64ProfileImage: action.payload, isProfileImageModified: true };
      case UPDATE_SELECTED_PAYMENT_TYPE:
        return { ...state, selectedPaymentType: action.payload };
      case UPDATE_EDUCATIONAL_INSTITUTION:
        return { ...state, educationalInstitution: action.payload };
      case UPDATE_SELECTED_TEAM:
        return { ...state, selectedTeam: action.payload };
      case ADD_COMMENT:
        return { ...state, comments: [...state.comments, action.payload] };
      case UPDATE_SIGNATURE_IMAGE:
        return { ...state, base64SignatureImage: action.payload };
      case UPDATE_EXAMINATION_RESULT_DATE:
        return { ...state, examinationResultDate: action.payload };
      case UPDATE_EXAMINATION_RESULT_TYPE:
        return { ...state, examinationResultType: action.payload };
      case UPDATE_CHOSEN_EDUCATIONAL_COURSE_TYPE:
        return { ...state, chosenEducationalCourseType: action.payload };
      case UPDATE_PREVIOUS_CERTIFICATE_EXPIRE_DATE:
        return { ...state, previousCertificateExpireDate: action.payload };
      default:
        if (state.certificateType === CertificateType.Tax) {
          state = applicationForTaxReducer(state, action);
        } else if (state.certificateType === CertificateType.Cub) {
          state = applicationForCubReducer(state as IApplicationForCubVm, action);
        } else if (state.certificateType === CertificateType.Vub) {
          state = applicationForVubReducer(state, action);
        } else if (state.certificateType === CertificateType.Adr) {
          state = applicationForAdrReducer(state as IApplicationForAdrVm, action);
        } else if (state.certificateType === CertificateType.Sta) {
          state = applicationForStaReducer(state as IApplicationForStaVm, action);
        }
        return { ...state, driverLicense: driverLicenseReducer.default(state.driverLicense, action) };
    }
  } else {
    const newState = state as IApplicationForTaxCaseWorkerVm;

    return {
      ...state,
      citizen: citizenReducer.default(state.citizen as ICitizenVm, action),
      invoices: invoiceReducers.default(newState.invoices, action),
      driverLicense: driverLicenseReducer.default(newState.driverLicense, action),
      comments: commentsReducer.default(newState.comments, action),
      companyChosenForPayment: companyReducer(newState.companyChosenForPayment, action),
    } as IApplicationForTaxCaseWorkerVm;
  }
}

// Reducer for Tax specific properties
function applicationForTaxReducer(state: IApplicationVm = new InitState().application, action: IAction): IApplicationVm {
  let newState: any;
  switch (action.type) {
    case REPLACE_CITIZEN:
      return { ...state, citizen: action.payload };
    case UPDATE_APPLICATION_IS_NAME_CONFIRMED:
      return { ...state, isNameConfirmed: action.payload } as IApplicationForTaxChangeVm;
    case UPDATE_PROFILE_IMAGE_FOR_RESUBMIT:
      return { ...state, base64ProfileImage: action.payload.image, profileImageCardStatus: action.payload.cardStatusType, isProfileImageModified: true };
    case UPDATE_PROFILE_IMAGE_CARD_STATUS:
      return { ...state, profileImageCardStatus: action.payload };
    case UPDATE_MEDICAL_CERTIFICATE_MARKED_AS_SENT:
      return { ...state, medicalCertificateMarkedAsSent: action.payload } as IApplicationForTaxIssuingVm | IApplicationForTaxRenewalVm;
    case UPDATE_IS_STATEMENT_OF_CONSENT_CRIMINAL_RECORD_ACCEPTED:
      return { ...state, isStatementOfConsentCriminalRecordAccepted: action.payload } as IApplicationForTaxRenewalVm | IApplicationForTaxIssuingVm;
    case UPDATE_IS_STATEMENT_OF_CONSENT_MEDICAL_CERTIFICATE_ACCEPTED:
      return { ...state, isStatementOfConsentMedicalCertificateAccepted: action.payload } as IApplicationForTaxRenewalVm | IApplicationForTaxIssuingVm;
    case UPDATE_CODE_OF_CONDUCT_STATUS:
      return { ...state, codeOfConductStatus: action.payload } as IApplicationForTaxCaseWorkerVm;
    case UPDATE_CRIMINAL_ASSESSMENT_STATUS:
      return { ...state, criminalAssessmentStatus: action.payload } as IApplicationForTaxCaseWorkerVm;
    case UPDATE_MEDICAL_CERTIFICATE_STATUS:
      return { ...state, medicalCertificateStatus: action.payload } as IApplicationForTaxCaseWorkerVm;
    case UPDATE_CERTIFICATE_EXPIRE_TIME_SPAN_ID:
      return { ...state, certificateExpireTimeSpanId: action.payload } as IApplicationForTaxCaseWorkerVm;
    default:
      newState = state as IApplicationForTaxChangeBasedOnExternalVm | IApplicationForTaxRenewalBasedOnExternalVm | IApplicationForTaxReplacementBasedOnExternalVm | IApplicationForTaxCaseWorkerVm;

      return {
        ...state,
        previousApplicationForTaxBasedOnExternal: applicationsForTaxBasedOnExternalReducer(newState.previousApplicationForTaxBasedOnExternal, action),
      } as IApplicationForTaxChangeBasedOnExternalVm | IApplicationForTaxRenewalBasedOnExternalVm | IApplicationForTaxReplacementBasedOnExternalVm | IApplicationForTaxCaseWorkerVm;
  }
}

// Reducer for Cub specific properties
function applicationForCubReducer(state: IApplicationForCubVm = new InitState().application as IApplicationForCubVm, action: IAction): IApplicationForCubVm {
  switch (action.type) {
    case UPDATE_IS_CONTINUING_EDUCATIOAN_BASED_ON_NON_BAT_APPLICATION:
      return { ...state, isContinuingEducationBasedOnNonBatApplication: action.payload } as IApplicationForCubVm;
    case UPDATE_SPECIAL_CONDITION_MET:
      return { ...state, isSpecialUkrainianApplication: action.payload } as IApplicationForCubVm;
    case UPDATE_HEALTH_CONDITION_MET:
      return { ...state, healthInformationIsApproved: action.payload } as IApplicationForCubVm;
    default:
      return state;
  }
}

// Reducer for Cub specific properties
function applicationForVubReducer(state: IApplicationVm = new InitState().application, action: IAction): IApplicationVm {
  switch (action.type) {
    // So far there is nothing specific to update for VUB
    default:
      return state;
  }
}

// Reducer for STA specific properties
function applicationForStaReducer(state: IApplicationForStaVm = new InitState().application as IApplicationForStaVm, action: IAction): IApplicationForStaVm {
  switch (action.type) {
    default: {
      const newState = state as IApplicationForStaVm;
      return {
        ...state,
        criminalRecordDeclaration: criminalRecordDeclarationReducer(newState.criminalRecordDeclaration, action),
      };
    }
  }
}

// Reducer for ADR specific properties
function applicationForAdrReducer(state: IApplicationForAdrVm = new InitState().application as IApplicationForAdrVm, action: IAction): IApplicationForAdrVm {
  switch (action.type) {
    case UPDATE_APPLICABILITY_TYPE:
      return { ...state, chosenApplicabilityType: action.payload } as IApplicationForAdrVm;
    case UPDATE_HAS_PREVIOUS_APPLICATION_DATE:
      return { ...state, hasPreviousCertificateExpireDate: action.payload } as IApplicationForAdrVm;
    case UPDATE_ATTENDING_SPECIAL_COURSE:
      return { ...state, attendingSpecialCourse: action.payload } as IApplicationForAdrVm;
    default:
      return state;
  }
}

// Is called when page is changed on the search page
export function updateApplicationSearchListPageNumberAndSearch(pageNumber: number) {
  return async (dispatch: Dispatch<any>, getState: () => InitState) => {
    const searchObject = getState().meta.applicationSearchObject;
    const sortObject = getState().meta.applicationSearchSort;

    dispatch(metaReducer.updateApplicationSearchListPageNumber(pageNumber));
    dispatch(searchApplications(searchObject, sortObject, pageNumber));
  };
}

// Is called when a sort property is changed on the search page
export function updateApplicationSearchListSortPropertyAndSearch(sortObject: ISortObject) {
  return async (dispatch: Dispatch<any>, getState: () => InitState) => {
    const searchObject = getState().meta.applicationSearchObject;
    const pageNumber = getState().meta.applicationSearchListPageNumber;

    dispatch(metaReducer.updateApplicationSearchListSortProperty(sortObject));
    dispatch(searchApplications(searchObject, sortObject, pageNumber));
  };
}

// Is called when search button is pressed, and when the search site is loaded.
export function updateApplicationSearchObjectAndSearch(searchObject: IApplicationSearchObject) {
  return async (dispatch: Dispatch<any>, getState: () => InitState) => {
    // When search button is pressed, we set pageNumber to 1.
    dispatch(metaReducer.updateApplicationSearchListPageNumber(1));

    const pageNumber = getState().meta.applicationSearchListPageNumber;
    const sortObject = getState().meta.applicationSearchSort;

    dispatch(metaReducer.updateApplicationSearchObject(searchObject));
    dispatch(searchApplications(searchObject, sortObject, pageNumber));
  };
}

function searchApplications(applicationSearchObject: IApplicationSearchObject, sortObject: ISortObject, pageNumber: number) {
  return async (dispatch: Dispatch<any>) => {
    const currentUser = UserHelper.currentUser();
    let applicationBaseSearchDto: IApplicationBaseSearchVm;

    try {
      switch (currentUser.type) {
        case UserType.EducationalWorker:
          applicationBaseSearchDto = await Api.educationalInstitution.searchApplications(sortObject.sortPropertyName, sortObject.sortOrderASC, pageNumber, applicationSearchObject);
          break;
        case UserType.IssuingAuthorityCaseworker:
        case UserType.IssuingAuthorityAdministrativeCaseWorker:
          applicationBaseSearchDto = await Api.issuingAuthorityCaseworker.searchApplications(sortObject.sortPropertyName, sortObject.sortOrderASC, pageNumber, applicationSearchObject);
          break;
      }

      // Replace applications with the returned applications and update number of applications
      dispatch({ type: REPLACE_APPLICATIONS, payload: applicationBaseSearchDto.applicationBaseList });
      dispatch(metaReducer.updateApplicationSearchListTotalRowsCount(applicationBaseSearchDto.count));
    } catch (error) {
      // Not implemented
    }
  };
}

/**
 * Get application from from backend
 * @param certificateType
 * @param applicationId
 */
export function getApplication(certificateType: CertificateType, applicationId: string) {
  return async (dispatch: Dispatch<any>) => {
    const currentUser = UserHelper.currentUser();
    if (Guid.isGuid(applicationId) && (currentUser.type === UserType.EducationalWorker || currentUser.type === UserType.IssuingAuthorityCaseworker || currentUser.type === UserType.IssuingAuthorityAdministrativeCaseWorker)) {
      const application = await Api.shared.getApplication(certificateType, applicationId);
      dispatch(reloadApplication(application));
    }
  };
}

/**
 *  Method for creating a new application
 * @param certificateType
 * @param certificateProcessType
 * @param citizen Citizen object that should be attached to the new application
 * @param selectedIssuingMunicipality  Add to application if selected in visitation tree
 */
export function createApplication(certificateType: CertificateType, certificateProcessType: CertificateProcessType, citizen: ICitizenVm, selectedIssuingMunicipality?: IMunicipalityVm) {
  return async (dispatch: Dispatch<any>) => {
    const currentUser = UserHelper.currentUser();

    switch (certificateType) {
      case CertificateType.Tax:
        dispatch(createApplicationForTax(certificateProcessType, citizen, currentUser, selectedIssuingMunicipality));
        break;
      case CertificateType.Cub:
        dispatch(createApplicationForCub(certificateProcessType, citizen, currentUser));
        break;
      case CertificateType.Sta:
        dispatch(createApplicationForSta(certificateProcessType, citizen, currentUser));
        break;
      case CertificateType.Vub:
        dispatch(createApplicationForVub(certificateProcessType, citizen, currentUser));
        break;
      case CertificateType.Adr:
        dispatch(createApplicationForAdr(certificateProcessType, citizen, currentUser));
        break;
    }
  };
}

// Adds a new application to reducer
function createApplicationForTax(certificateProcessType: CertificateProcessType, citizen: ICitizenVm, currentUser: IUserVm, issuingMunicipality?: IMunicipalityVm) {
  return async (dispatch: Dispatch<any>) => {
    let newTaxApplication: IApplicationVm = {
      ...IApplicationVmInstance.empty(),
      id: Math.random().toString(),
      certificateType: CertificateType.Tax,
      certificateProcessType,
      citizen,
      status: ApplicationStatusType.Pending,
      companyChosenForPayment: null,
      applicationSubmittetByEducationalInstitutionStatus: ApplicationSubmitStatusType.NotSubmitted,
      applicationSubmittetByCitizenStatus: ApplicationSubmitStatusType.NotSubmitted,
    };

    if (certificateProcessType === CertificateProcessType.ChangeBasedOnExternal || certificateProcessType === CertificateProcessType.ReplacementBasedOnExternal) {
      const obj = IApplicationForTaxBasedOnExternalVmInstance.empty();
      if (!!issuingMunicipality) {
        obj.issuingMunicipality = issuingMunicipality;
        obj.licenseType = FormerLicenseType.TaxLicense;
      }
      (newTaxApplication as IApplicationForTaxRenewalBasedOnExternalVm | IApplicationForTaxChangeBasedOnExternalVm).previousApplicationForTaxBasedOnExternal = obj;
    }

    try {
      if (currentUser.type === UserType.Citizen) {
        newTaxApplication = await Api.citizen.saveApplicationForTax(newTaxApplication);
      }
      dispatch(metaReducer.setSelectedApplication(newTaxApplication));
    } catch (error) {
      throw error;
    }
  };
}

function createApplicationForCub(certificateProcessType: CertificateProcessType, citizen: ICitizenVm, currentUser: IUserVm) {
  return async (dispatch: Dispatch<any>) => {
    const commentForEdu = {
      ...ICommentVmInstance.empty(),
      id: Math.random().toString(),
      text: "",
      associatedEducationalInstitution: {
        ...IEducationalInstitutionVmInstance.empty(),
        id: currentUser.organization !== null ? currentUser.organization.id : "",
      },
    };

    let newCubApplication: IApplicationVm = {
      ...IApplicationVmInstance.empty(),
      id: Math.random().toString(),
      certificateType: CertificateType.Cub,
      certificateProcessType,
      status: ApplicationStatusType.Pending,
      citizen,
      companyChosenForPayment: null,
      comments: [commentForEdu],
    };

    try {
      // If new application is created by citizen, we save the application on create.
      // If returned object does not contain a certificateNumber, we assume an error accoured, and do not reload.
      if (currentUser.type === UserType.Citizen) {
        newCubApplication = await Api.citizen.saveApplicationForCub(newCubApplication);
        if (!!newCubApplication.certificateNumber) {
          dispatch(metaReducer.setSelectedApplication(newCubApplication));
        }
      }
      // If new application is a Change or Replacement, and is created by a educational worker, we save the application on create
      // If returned object does not contain a certificateNumber, we assume an error accoured, and do not reload.
      if (currentUser.type === UserType.EducationalWorker && (certificateProcessType === CertificateProcessType.Change || certificateProcessType === CertificateProcessType.Replacement)) {
        newCubApplication = await Api.educationalInstitution.saveApplicationForCub(newCubApplication);
        if (!!newCubApplication.certificateNumber) {
          dispatch(metaReducer.setSelectedApplication(newCubApplication));
          dispatch(
            metaReducer.addToastr({
              message: i18n.t("TEXT_APPLICATION_CREATED"),
              type: "success",
            })
          );
        }
      } else {
        dispatch(metaReducer.setSelectedApplication(newCubApplication));
      }
    } catch (error) {
      throw error;
    }
  };
}

function createApplicationForSta(certificateProcessType: CertificateProcessType, citizen: ICitizenVm, currentUser: IUserVm) {
  return async (dispatch: Dispatch<any>) => {
    const commentForEdu = {
      ...ICommentVmInstance.empty(),
      id: Math.random().toString(),
      text: "",
      associatedEducationalInstitution: {
        ...IEducationalInstitutionVmInstance.empty(),
        id: currentUser.organization !== null ? currentUser.organization.id : "",
      },
    };

    let newStaApplication: IApplicationVm = {
      ...IApplicationForStaVmInstance.empty(),
      id: Math.random().toString(),
      certificateType: CertificateType.Sta,
      certificateProcessType,
      status: ApplicationStatusType.Pending,
      citizen,
      companyChosenForPayment: null,
      comments: [commentForEdu],
    };

    try {
      // If new application is created by citizen, we save the application on create.
      // If returned object does not contain a certificateNumber, we assume an error accoured, and do not reload.
      if (currentUser.type === UserType.Citizen) {
        newStaApplication = await Api.citizen.saveApplicationForSta(newStaApplication);
        if (!!newStaApplication.certificateNumber) {
          dispatch(metaReducer.setSelectedApplication(newStaApplication));
        }
      }
      // If new application is a Change or Replacement, and is created by a educational worker, we save the application on create
      // If returned object does not contain a certificateNumber, we assume an error accoured, and do not reload.
      if (currentUser.type === UserType.EducationalWorker && (certificateProcessType === CertificateProcessType.Change || certificateProcessType === CertificateProcessType.Replacement)) {
        newStaApplication = await Api.educationalInstitution.saveApplicationForSta(newStaApplication);
        if (!!newStaApplication.certificateNumber) {
          dispatch(metaReducer.setSelectedApplication(newStaApplication));
          dispatch(
            metaReducer.addToastr({
              message: i18n.t("TEXT_APPLICATION_CREATED"),
              type: "success",
            })
          );
        }
      } else {
        dispatch(metaReducer.setSelectedApplication(newStaApplication));
      }
    } catch (error) {
      throw error;
    }
  };
}

function createApplicationForVub(certificateProcessType: CertificateProcessType, citizen: ICitizenVm, currentUser: IUserVm) {
  return async (dispatch: Dispatch<any>) => {
    const commentForEdu = {
      ...ICommentVmInstance.empty(),
      id: Math.random().toString(),
      text: "",
      associatedEducationalInstitution: {
        ...IEducationalInstitutionVmInstance.empty(),
        id: currentUser.organization !== null ? currentUser.organization.id : "",
      },
    };

    let newVubApplication: IApplicationVm = {
      ...IApplicationVmInstance.empty(),
      id: Math.random().toString(),
      certificateType: CertificateType.Vub,
      certificateProcessType,
      status: ApplicationStatusType.Pending,
      citizen,
      companyChosenForPayment: null,
      comments: [commentForEdu],
    };

    try {
      // If new application is created by citizen, we save the application on create.
      // If returned object does not contain a certificateNumber, we assume an error accoured, and do not reload.
      if (currentUser.type === UserType.Citizen) {
        newVubApplication = await Api.citizen.saveApplicationForVub(newVubApplication);
        if (!!newVubApplication.certificateNumber) {
          dispatch(metaReducer.setSelectedApplication(newVubApplication));
        }
      }
      // If new application is a Change or Replacement, and is created by a educational worker, we save the application on create
      // If returned object does not contain a certificateNumber, we assume an error accoured, and do not reload.
      if (currentUser.type === UserType.EducationalWorker && (certificateProcessType === CertificateProcessType.Change || certificateProcessType === CertificateProcessType.Replacement)) {
        newVubApplication = await Api.educationalInstitution.saveApplicationForVub(newVubApplication);
        if (!!newVubApplication.certificateNumber) {
          dispatch(metaReducer.setSelectedApplication(newVubApplication));
          dispatch(
            metaReducer.addToastr({
              message: i18n.t("TEXT_APPLICATION_CREATED"),
              type: "success",
            })
          );
        }
      } else {
        dispatch(metaReducer.setSelectedApplication(newVubApplication));
      }
    } catch (error) {
      throw error;
    }
  };
}

function createApplicationForAdr(certificateProcessType: CertificateProcessType, citizen: ICitizenVm, currentUser: IUserVm) {
  return async (dispatch: Dispatch<any>) => {
    const commentForEdu = {
      ...ICommentVmInstance.empty(),
      id: Math.random().toString(),
      text: "",
      associatedEducationalInstitution: {
        ...IEducationalInstitutionVmInstance.empty(),
        id: currentUser.organization !== null ? currentUser.organization.id : "",
      },
    };

    let newAdrApplication: IApplicationVm = {
      ...IApplicationVmInstance.empty(),
      id: Math.random().toString(),
      certificateType: CertificateType.Adr,
      certificateProcessType,
      status: ApplicationStatusType.Pending,
      citizen,
      companyChosenForPayment: null,
      comments: [commentForEdu],
    };

    try {
      // Set default Applicability Type
      (newAdrApplication as IApplicationForAdrIssuingVm).chosenApplicabilityType = ApplicabilityType.BasicEducation;
      // If new application is created by citizen, we save the application on create.
      // If returned object does not contain a certificateNumber, we assume an error accoured, and do not reload.
      if (currentUser.type === UserType.Citizen) {
        newAdrApplication = await Api.citizen.saveApplicationForAdr(newAdrApplication);
        if (!!newAdrApplication.certificateNumber) {
          dispatch(metaReducer.setSelectedApplication(newAdrApplication));
        }
      }
      // If new application is a Change or Replacement, and is created by a educational worker, we save the application on create
      // If returned object does not contain a certificateNumber, we assume an error accoured, and do not reload.
      if (currentUser.type === UserType.EducationalWorker && (certificateProcessType === CertificateProcessType.Change || certificateProcessType === CertificateProcessType.Replacement)) {
        newAdrApplication = await Api.educationalInstitution.saveApplicationForAdr(newAdrApplication);
        if (!!newAdrApplication.certificateNumber) {
          dispatch(metaReducer.setSelectedApplication(newAdrApplication));
          dispatch(
            metaReducer.addToastr({
              message: i18n.t("TEXT_APPLICATION_CREATED"),
              type: "success",
            })
          );
        }
      } else {
        dispatch(metaReducer.setSelectedApplication(newAdrApplication));
      }
    } catch (error) {
      throw error;
    }
  };
}

async function saveApplicationForTax(application: IApplicationVm, currentUser: IUserVm) {
  switch (currentUser.type) {
    case UserType.Citizen:
      return await Api.citizen.saveApplicationForTax(application);
    case UserType.EducationalWorker:
      return await Api.educationalInstitution.saveApplicationForTax(application);
    case UserType.IssuingAuthorityCaseworker:
    case UserType.IssuingAuthorityAdministrativeCaseWorker:
      return await Api.issuingAuthorityCaseworker.saveApplicationForTax(application);
    default:
      return undefined;
  }
}

async function saveApplicationForCub(application: IApplicationVm, currentUser: IUserVm) {
  switch (currentUser.type) {
    case UserType.Citizen:
      return await Api.citizen.saveApplicationForCub(application);
    case UserType.EducationalWorker:
      return await Api.educationalInstitution.saveApplicationForCub(application);
    case UserType.IssuingAuthorityCaseworker:
    case UserType.IssuingAuthorityAdministrativeCaseWorker:
      return await Api.issuingAuthorityCaseworker.saveApplicationForCub(application);
    default:
      return undefined;
  }
}

async function saveApplicationForSta(application: IApplicationVm, currentUser: IUserVm) {
  switch (currentUser.type) {
    case UserType.Citizen:
      return await Api.citizen.saveApplicationForSta(application);
    case UserType.EducationalWorker:
      return await Api.educationalInstitution.saveApplicationForSta(application);
    case UserType.IssuingAuthorityCaseworker:
    case UserType.IssuingAuthorityAdministrativeCaseWorker:
      return await Api.issuingAuthorityCaseworker.saveApplicationForSta(application);
    default:
      return undefined;
  }
}

async function saveApplicationForVub(application: IApplicationVm, currentUser: IUserVm) {
  switch (currentUser.type) {
    case UserType.Citizen:
      return await Api.citizen.saveApplicationForVub(application);
    case UserType.EducationalWorker:
      return await Api.educationalInstitution.saveApplicationForVub(application);
    case UserType.IssuingAuthorityCaseworker:
    case UserType.IssuingAuthorityAdministrativeCaseWorker:
      return await Api.issuingAuthorityCaseworker.saveApplicationForVub(application);
    default:
      return undefined;
  }
}

async function saveApplicationForAdr(application: IApplicationVm, currentUser: IUserVm) {
  switch (currentUser.type) {
    case UserType.Citizen:
      return await Api.citizen.saveApplicationForAdr(application);
    case UserType.EducationalWorker:
      return await Api.educationalInstitution.saveApplicationForAdr(application);
    case UserType.IssuingAuthorityCaseworker:
    case UserType.IssuingAuthorityAdministrativeCaseWorker:
      return await Api.issuingAuthorityCaseworker.saveApplicationForAdr(application);
    default:
      return undefined;
  }
}

/**
 * Sets selectedApplicationId and selectedApplicationPristine.
 * @param application application The application that is selected
 */
export function reloadApplication(application: IApplicationVm) {
  return async (dispatch: Dispatch<any>) => {
    if (!!application) {
      // These dispatches makes sure that the application is being removed and added/readded to the list of applications saved in the state.
      // REPLACE_APPLICATION can not be used in this case, because the application can be a new application,
      // and therefore not represented in the current list of applications. REMOVE_APPLICATION will remove the application if it finds a
      // application in the list, with the same id that we want to add.
      dispatch({ type: REMOVE_APPLICATION, payload: application.id });
      dispatch({ type: ADD_APPLICATION, payload: application });
      dispatch({ type: metaReducer.SET_SELECTED_PRISTINE, payload: application });
      dispatch({ type: metaReducer.SET_SELECTED_APPLICATION, payload: application.id });
    }
  };
}

/**
 * Removes the selectedApplicationId and selectedApplicationPristine from state.
 */
export function unloadApplication() {
  return async (dispatch: Dispatch<any>, getState: () => InitState) => {
    const selectedApplicationId = getState().meta.selectedApplicationId;
    const selectedApplicationForPristine = getState().meta.selectedApplicationPristine;

    if (!!selectedApplicationId) {
      dispatch({ type: metaReducer.SET_SELECTED_APPLICATION, payload: "" });
    }

    if (!!selectedApplicationForPristine) {
      dispatch({ type: metaReducer.SET_SELECTED_PRISTINE, payload: IApplicationVmInstance.empty() });
    }
  };
}

/**
 * Method for saving an application as citizen, educational worker and caseworker.
 * @param application Application to be saved
 * @param createNewDraftAfterSave Create an empty draft after save
 */
export function saveApplication(application: IApplicationVm, createNewDraftAfterSave?: boolean): (dispatch: Dispatch<any>, getState: () => InitState) => Promise<void> {
  return async (dispatch: any, getState: () => InitState) => {
    const currentUser = UserHelper.currentUser();
    const isNewApplication = !Guid.isGuid(application.id); // If id is a valid GUID, it already exist

    try {
      const pristineApplication = getState().meta.selectedApplicationPristine;
      let savedApplication: IApplicationVm;

      // Only call backend if there has been made changes to the application. This is to prevent calling backend with a unchanged application.
      if (JSON.stringify(application) !== JSON.stringify(pristineApplication)) {
        switch (application.certificateType) {
          case CertificateType.Tax:
            savedApplication = await saveApplicationForTax(application, currentUser);
            break;
          case CertificateType.Cub:
            savedApplication = await saveApplicationForCub(application, currentUser);
            break;
          case CertificateType.Sta:
            savedApplication = await saveApplicationForSta(application, currentUser);
            break;
          case CertificateType.Vub:
            savedApplication = await saveApplicationForVub(application, currentUser);
            break;
          case CertificateType.Adr:
            savedApplication = await saveApplicationForAdr(application, currentUser);
            break;
          default:
            savedApplication = undefined;
        }

        // If returned JSON object contains a property with a certificateNumber, we can assume that it is an ApplicationVm
        // and that the application was saved correctly.
        // If not, we are calling api to get the application, to sync the version between backend and frontend.
        if (!!savedApplication.certificateNumber) {
          // If userType is not citizen, show toast that indicates that saving application was succesfull
          if (currentUser.type !== UserType.Citizen) {
            dispatch(
              metaReducer.addToastr({
                message: i18n.t("TEXT_APPLICATION_SAVED"),
                type: "success",
              })
            );
          }

          dispatch(reloadApplication(savedApplication));
        } else if (Guid.isGuid(application.id)) {
          savedApplication = await Api.shared.getApplication(application.certificateType, application.id);
          dispatch(reloadApplication(savedApplication));
        }
      }

      if (createNewDraftAfterSave) {
        dispatch(createApplication(application.certificateType, application.certificateProcessType, ICitizenVmInstance.empty()));
        dispatch(push("/edit_application/" + application.certificateType + "/" + application.certificateProcessType + "/-1"));
        window.scrollTo(0, 0);
      } else if (isNewApplication && !createNewDraftAfterSave) {
        dispatch(push("/edit_application/" + savedApplication.certificateType + "/" + application.certificateProcessType + "/" + savedApplication.id));
      }
    } catch (error) {
      throw error;
    } finally {
      dispatch(metaReducer.setDisableSpinner(false));
    }
  };
}

/**
 * Method for approving an application as caseworker.
 * * @param application Application to be submitted
 */
export function approveApplicationAsCaseworker(application: IApplicationVm): (dispatch: Dispatch<any>) => Promise<void> {
  return async (dispatch: Dispatch<any>) => {
    let approvedApplication: IApplicationVm;
    let message: string;
    try {
      if (application.certificateType === CertificateType.Tax) {
        approvedApplication = await Api.issuingAuthorityCaseworker.approveApplicationForTax(application);
        message = i18n.t("TEXT_APPLICATION_APPROVED");
      }

      if (!!approvedApplication.certificateNumber) {
        dispatch(reloadApplication(approvedApplication));
        dispatch(metaReducer.addToastr({ message, type: "success" }));
      } else {
        const refetchedApplication = await Api.shared.getApplication(application.certificateType, application.id);
        dispatch(reloadApplication(refetchedApplication));
      }
    } catch (error) {
      // Not implemented
    }
  };
}

export function submitApplicationAsEducationalWorker(application: IApplicationVm): (dispatch: Dispatch<any>) => Promise<void> {
  return async (dispatch: Dispatch<any>) => {
    let submittedApplication: IApplicationVm;
    let savedApplication: IApplicationVm;
    let message: string;
    try {
      switch (application.certificateType) {
        case CertificateType.Tax:
          savedApplication = await Api.educationalInstitution.saveApplicationForTax(application);
          break;
        case CertificateType.Cub:
          savedApplication = await Api.educationalInstitution.saveApplicationForCub(application);
          break;
        case CertificateType.Sta:
          savedApplication = await Api.educationalInstitution.saveApplicationForSta(application);
          break;
        case CertificateType.Vub:
          savedApplication = await Api.educationalInstitution.saveApplicationForVub(application);
          break;
        case CertificateType.Adr:
          savedApplication = await Api.educationalInstitution.saveApplicationForAdr(application);
          break;
        default:
          throw new Error("CertificateType is not valid");
      }

      if (!!savedApplication && !!savedApplication.certificateNumber) {
        dispatch(reloadApplication(savedApplication));

        if (savedApplication.certificateType === CertificateType.Tax && savedApplication.applicationSubmittetByEducationalInstitutionStatus === ApplicationSubmitStatusType.NeedsResubmittal) {
          submittedApplication = await Api.educationalInstitution.resubmitApplicationForTax(savedApplication.id);
          message = i18n.t("TEXT_APPLICATION_RESUBMITTED");
        } else {
          switch (application.certificateType) {
            case CertificateType.Tax:
              submittedApplication = await Api.educationalInstitution.submitApplicationForTax(savedApplication.id);
              break;
            case CertificateType.Cub:
              submittedApplication = await Api.educationalInstitution.submitAndApproveApplicationForCub(savedApplication.id);
              break;
            case CertificateType.Sta:
              submittedApplication = await Api.educationalInstitution.submitAndApproveApplicationForSta(savedApplication.id);
              break;
            case CertificateType.Vub:
              submittedApplication = await Api.educationalInstitution.submitAndApproveApplicationForVub(savedApplication.id);
              break;
            case CertificateType.Adr:
              submittedApplication = await Api.educationalInstitution.submitAndApproveApplicationForAdr(savedApplication.id);
              break;
            default:
              throw new Error("CertificateType is not valid");
          }

          message = i18n.t("TEXT_APPLICATION_SUBMITTED");
        }
      }

      // If returned application contains a certificateNumber, we assume that it went successfully
      if (!!submittedApplication && !!submittedApplication.certificateNumber) {
        dispatch(reloadApplication(submittedApplication));
        dispatch(metaReducer.addToastr({ message, type: "success" }));
      }
      // If application has not been saved until now (edu worker can work with drafts that is not created in database),
      // it does not contain a valid GUID id, and therefore it will trigger an error when backend is called
      else if (Guid.isGuid(application.id)) {
        const refetchedApplication = await Api.shared.getApplication(application.certificateType, application.id);
        dispatch(reloadApplication(refetchedApplication));
      }
    } catch (error) {
      // Not implemented
    }
  };
}

/**
 * Method for submitting an application as citizen.
 * * @param application Application to be submitted
 */
export function submitApplicationAsCitizen(application: IApplicationVm): (dispatch: Dispatch<any>) => Promise<void> {
  return async (dispatch: Dispatch<any>) => {
    let submittedApplication;
    try {
      if (application.certificateType === CertificateType.Tax && application.applicationSubmittetByCitizenStatus === ApplicationSubmitStatusType.NeedsResubmittal) {
        submittedApplication = await Api.citizen.resubmitApplicationForTax(application);
      } else {
        switch (application.certificateType) {
          case CertificateType.Tax:
            submittedApplication = await Api.citizen.submitApplicationForTax(application);
            break;
          case CertificateType.Cub:
            submittedApplication = await Api.citizen.submitApplicationForCub(application);
            break;
          case CertificateType.Sta:
            submittedApplication = await Api.citizen.submitApplicationForSta(application);
            break;
          case CertificateType.Vub:
            submittedApplication = await Api.citizen.submitApplicationForVub(application);
            break;
          case CertificateType.Adr:
            submittedApplication = await Api.citizen.submitApplicationForAdr(application);
            break;
        }
      }

      // If returned application contains a certificateNumber, we assume that it went successfully
      if (!!submittedApplication && !!submittedApplication.certificateNumber) {
        dispatch(reloadApplication(submittedApplication));

        // If certificateType is Vub or Cub, refetch the previousApplicationForVub/previousApplicationForCub due to automatic status changes made by backend
        let previousApplicationId: string;
        switch (submittedApplication.certificateType) {
          case CertificateType.Vub:
            previousApplicationId = (submittedApplication as IApplicationForVubVm).previousApplicationForVub.id;
            break;
          case CertificateType.Cub:
            previousApplicationId = (submittedApplication as IApplicationForCubVm).previousApplicationForCub.id;
            break;
          case CertificateType.Sta:
            previousApplicationId = (submittedApplication as IApplicationForStaVm).previousApplicationForSta.id;
            break;
          case CertificateType.Tax:
            previousApplicationId = (submittedApplication as IApplicationForTaxVm).previousApplicationForTax.id;
            break;
          default:
            previousApplicationId = null;
        }

        if (!!previousApplicationId) {
          const previousApplication = await Api.shared.getApplication(submittedApplication.certificateType, previousApplicationId);
          dispatch({ type: REPLACE_APPLICATION, payload: previousApplication });
        }
      }

      // If call did not go successfully, we refetch the application to make sure it is sync with backend
      else {
        const refetchedApplication = await Api.shared.getApplication(application.certificateType, application.id);
        dispatch(reloadApplication(refetchedApplication));
      }
    } catch (error) {
      // Not implemented
    }
  };
}

/**
 * Method that calls backend when caseworker rejects one or more cards, and resend it back to the applicant/citizen
 * * @param application Application to be returned for resubmittal
 */
export function returnApplicationForTaxForResubmittal(application: IApplicationVm): (dispatch: Dispatch<any>) => Promise<void> {
  return async (dispatch: Dispatch<any>) => {
    // Set ApplicationSubmitStatusType before sending to backend.
    // If CertificateProcessType is Issuing, set for applicationSubmittetByEducationalInstitutionStatus, else for applicationSubmittetByCitizenStatus.
    // Changing values directly on the object is not a good practice, but is necceserary, because dispatching is not changing the state directly after it is called.
    let tempApplication: IApplicationVm;
    switch (application.certificateProcessType) {
      case CertificateProcessType.Issuing:
        tempApplication = { ...application, applicationSubmittetByEducationalInstitutionStatus: ApplicationSubmitStatusType.NeedsResubmittal };
        break;
      default:
        tempApplication = { ...application, applicationSubmittetByCitizenStatus: ApplicationSubmitStatusType.NeedsResubmittal };
        break;
    }

    const updatedApplication: IApplicationVm = await Api.issuingAuthorityCaseworker.returnApplicationForTaxForResubmittal(tempApplication);

    // If returned object contains a certificateNumber, the call was succesfull
    if (!!updatedApplication.certificateNumber) {
      const message = updatedApplication.certificateProcessType === CertificateProcessType.Issuing ? i18n.t("TEXT_RETURN_TO_EDUCATIONAL_INSTITUTION_MESSAGE") : i18n.t("TEXT_RETURN_TO_CITIZEN_MESSAGE");

      dispatch(reloadApplication(updatedApplication));
      dispatch(metaReducer.addToastr({ message, type: "success" }));
    } else {
      const refetchedApplication = await Api.shared.getApplication(application.certificateType, application.id);
      dispatch(reloadApplication(refetchedApplication));
    }
  };
}

export function submitOnBehalfOfCitizen(application: IApplicationVm): (dispatch: Dispatch<any>) => Promise<void> {
  return async (dispatch: Dispatch<any>) => {
    // Handled in backend instead. We're basically just sending the application
    // tempApplication = { ...application, applicationSubmittetByCitizenStatus: ApplicationSubmitStatusType.Submitted}
    const tempApplication: IApplicationVm = { ...application };
    const updatedApplication: IApplicationVm = await Api.issuingAuthorityCaseworker.submitOnBehalfOfCitizen(tempApplication);

    // If returned object contains a certificateNumber, the call was succesfull
    if (!!updatedApplication.certificateNumber) {
      const message = i18n.t("TEXT_SUBMIT_ON_BEHALF_OF_APPLICANT_MESSAGE");

      dispatch(reloadApplication(updatedApplication));
      dispatch(metaReducer.addToastr({ message, type: "success" }));
    } else {
      const refetchedApplication = await Api.shared.getApplication(application.certificateType, application.id);
      dispatch(reloadApplication(refetchedApplication));
    }
  };
}

/**
 * Method to mark application as deleted
 * * @param application Application to be marked as deleted
 */
export function deleteApplication(application: IApplicationVm): (dispatch: Dispatch<any>) => Promise<void> {
  return async (dispatch: Dispatch<any>) => {
    const deletedApplication = await Api.shared.markApplicationAsDeleted(application.id);

    // If application was deleted successfully
    if (deletedApplication.status === ApplicationStatusType.MarkedAsDeleted) {
      // Remove application from list
      dispatch({ type: REMOVE_APPLICATION, payload: application.id });

      // Show toaster
      dispatch(
        metaReducer.addToastr({
          message: `Ansøgning ${deletedApplication.certificateNumber} slettet`,
          type: "success",
        })
      );

      // Redirect to frontpage
      dispatch(push("/"));
    }
  };
}

export function createNewApplicationBasedOnErrornousApplication(application: IApplicationVm): (dispatch: Dispatch<any>) => Promise<void> {
  return async (dispatch: Dispatch<any>) => {
    const newApplication = await Api.IssuingAuthorityAdministrativeCaseWorker.createNewApplicationBasedOnErrornousApplication(application);
    if (!!(newApplication as IApplicationVm).id && newApplication.id !== "00000000-0000-0000-0000-000000000000") {
      dispatch(push("/edit_application/" + newApplication.certificateType + "/" + newApplication.certificateProcessType + "/" + newApplication.id + "/0"));
      dispatch(reloadApplication(newApplication));
      dispatch(
        metaReducer.addToastr({
          message: `Ny ansøgning oprettet og ansøgning ${application.certificateNumber} er annulleret`,
          type: "success",
        })
      );
      window.scrollTo(0, 0);
    }
  };
}

export function cancelCertificateDueToErrorsOnCertificate(applicationId: string): (dispatch: Dispatch<any>) => Promise<void> {
  return async (dispatch: Dispatch<any>) => {
    let canceledApplication = await Api.IssuingAuthorityAdministrativeCaseWorker.cancelCertificateDueToErrorsOnCertificate(applicationId);

    if (!!canceledApplication && Guid.isGuid(canceledApplication.id)) {
      canceledApplication = await Api.shared.getApplication(canceledApplication.certificateType, canceledApplication.id);
      dispatch(reloadApplication(canceledApplication));

      dispatch(
        metaReducer.addToastr({
          message: "Bevis annulleret",
          type: "success",
        })
      );
    }
  };
}

export function cancelApplicationDueToErrorsInApplication(applicationId: string): (dispatch: Dispatch<any>) => Promise<void> {
  return async (dispatch: Dispatch<any>) => {
    let canceledApplication = await Api.IssuingAuthorityAdministrativeCaseWorker.cancelApplicationDueToErrorsInApplication(applicationId);

    if (!!canceledApplication && Guid.isGuid(canceledApplication.id)) {
      canceledApplication = await Api.shared.getApplication(canceledApplication.certificateType, canceledApplication.id);
      dispatch(reloadApplication(canceledApplication));

      dispatch(
        metaReducer.addToastr({
          message: "Ansøgningen annulleret",
          type: "success",
        })
      );
    }
  };
}

export function revokeApplication(applicationId: string): (dispatch: Dispatch<any>) => Promise<void> {
  return async (dispatch: Dispatch<any>) => {
    let revokedApplication = await Api.IssuingAuthorityAdministrativeCaseWorker.revokeCertificate(applicationId);

    if (!!revokedApplication && Guid.isGuid(revokedApplication.id)) {
      revokedApplication = await Api.shared.getApplication(revokedApplication.certificateType, revokedApplication.id);
      dispatch(reloadApplication(revokedApplication));

      dispatch(
        metaReducer.addToastr({
          message: "Beviset er tilbagekaldt",
          type: "success",
        })
      );
    }
  };
}

export function reactivateRevokedApplication(applicationId: string): (dispatch: Dispatch<any>) => Promise<void> {
  return async (dispatch: Dispatch<any>) => {
    let reactivatedApplication = await Api.IssuingAuthorityAdministrativeCaseWorker.reactivateRevokedCertificate(applicationId);

    if (!!reactivatedApplication && Guid.isGuid(reactivatedApplication.id)) {
      reactivatedApplication = await Api.shared.getApplication(reactivatedApplication.certificateType, reactivatedApplication.id);
      dispatch(reloadApplication(reactivatedApplication));

      dispatch(
        metaReducer.addToastr({
          message: "Beviset er genaktiveret",
          type: "success",
        })
      );
    }
  };
}

/**
 * Method for rejecting an application as caseworker.
 * * @param application Application to be rejected
 */
export function rejectApplicationForTax(application: IApplicationForTaxVm): (dispatch: Dispatch<any>) => Promise<void> {
  return async (dispatch: Dispatch<any>) => {
    let rejectedApplication: IApplicationVm;
    let message: string;
    try {
      const savedApplication = await saveApplicationForTax(application, UserHelper.currentUser());

      if (!!savedApplication.certificateNumber) {
        rejectedApplication = await Api.issuingAuthorityCaseworker.rejectApplicationForTax(savedApplication.id);
        message = i18n.t("TEXT_APPLICATION_REJECTED");
      }
      if (!!rejectedApplication.certificateNumber) {
        dispatch(reloadApplication(rejectedApplication));
        dispatch(metaReducer.addToastr({ message, type: "success" }));
      } else {
        const refetchedApplication = await Api.shared.getApplication(application.certificateType, application.id);
        dispatch(reloadApplication(refetchedApplication));
      }
    } catch (error) {
      // Not implemented
    }
  };
}

// Exported functions for updating properties on application
export function updateExaminationResultType(value: ExaminationResultType, applicationId: string) {
  return { type: UPDATE_EXAMINATION_RESULT_TYPE, payload: +value, id: applicationId };
}
export function updateExaminationResultDate(value: string, applicationId: string) {
  return { type: UPDATE_EXAMINATION_RESULT_DATE, payload: value, id: applicationId };
}
export function updateProfileImageCardStatus(value: ApplicationCardStatusType, applicationId: string) {
  return { type: UPDATE_PROFILE_IMAGE_CARD_STATUS, payload: value, id: applicationId };
}
export function updateMedicalCertificateStatus(value: MedicalCertificateStatusType, applicationId: string) {
  return (dispatch: Dispatch<any>) => {
    dispatch({ type: UPDATE_CERTIFICATE_EXPIRE_TIME_SPAN_ID, payload: "", id: applicationId });
    dispatch({ type: UPDATE_MEDICAL_CERTIFICATE_STATUS, payload: value, id: applicationId });
  };
}
export function updateCertificateExpireTimeSpan(value: string, applicationId: string) {
  return { type: UPDATE_CERTIFICATE_EXPIRE_TIME_SPAN_ID, payload: value, id: applicationId };
}
export function updateCodeOfConductStatus(value: string, applicationId: string) {
  return { type: UPDATE_CODE_OF_CONDUCT_STATUS, payload: value, id: applicationId };
}
export function updateCriminalAssessmentStatus(value: string, applicationId: string) {
  return { type: UPDATE_CRIMINAL_ASSESSMENT_STATUS, payload: value, id: applicationId };
}
export function updateEducationalInstitution(value: IEducationalInstitutionVm, applicationId: string) {
  return { type: UPDATE_EDUCATIONAL_INSTITUTION, payload: value, id: applicationId };
}
export function updateIsStatementOfConsentCriminalRecordAccepted(isStatementOfConsentCriminalRecordAccepted: boolean, applicationId: string) {
  return { type: UPDATE_IS_STATEMENT_OF_CONSENT_CRIMINAL_RECORD_ACCEPTED, payload: isStatementOfConsentCriminalRecordAccepted, id: applicationId };
}
export function updateIsStatementOfConsentMedicalCertificateAccepted(isStatementOfConsentMedicalCertificateAccepted: boolean, applicationId: string) {
  return { type: UPDATE_IS_STATEMENT_OF_CONSENT_MEDICAL_CERTIFICATE_ACCEPTED, payload: isStatementOfConsentMedicalCertificateAccepted, id: applicationId };
}
export function updateMedicalCertificateMarkedAsSent(applicationId: string, isChecked: boolean) {
  return { type: UPDATE_MEDICAL_CERTIFICATE_MARKED_AS_SENT, payload: isChecked, id: applicationId };
}
export function updateIsNameConfirmed(applicationId: string, isNameConfirmed: boolean) {
  return { type: UPDATE_APPLICATION_IS_NAME_CONFIRMED, payload: isNameConfirmed, id: applicationId };
}
export function updateProfileImage(applicationId: string, image: string, findCrop: boolean) {
  return { type: UPDATE_PROFILE_IMAGE, payload: image, id: applicationId };
}
export function replaceCitizen(id: string, citizen: ICitizenVm) {
  return { type: REPLACE_CITIZEN, payload: citizen, id };
}
export function updateProfileImageForResubmit(applicationId: string, image: string, findCrop: boolean, cardStatusType: ApplicationCardStatusType) {
  return { type: UPDATE_PROFILE_IMAGE_FOR_RESUBMIT, payload: { image, cardStatusType }, id: applicationId };
}
export function updateSignatureImage(value: string, applicationId: string) {
  return { type: UPDATE_SIGNATURE_IMAGE, payload: value, id: applicationId };
}
export function updateTemporaryProfileImage(image: string, findCrop: boolean) {
  return async (dispatch: Dispatch<any>, getState: () => InitState) => {
    if (image && findCrop) {
      const crop = await Api.photo.findCropBox(image);
      dispatch(metaReducer.updateProfileImageCrop(crop));
    } else {
      dispatch(metaReducer.updateProfileImageCrop(null));
    }
    dispatch(metaReducer.updateTemporaryProfileImage(image));
  };
}
export function updateSelectedTeam(team: ITeamVm, applicationId: string) {
  return { type: UPDATE_SELECTED_TEAM, payload: team, id: applicationId };
}
export function updateChosenEducationalCourseType(value: EducationalCourseType, applicationId: string) {
  return { type: UPDATE_CHOSEN_EDUCATIONAL_COURSE_TYPE, payload: value, id: applicationId };
}
export function updateSelectedPaymentType(value: PaymentType, applicationId: string) {
  return { type: UPDATE_SELECTED_PAYMENT_TYPE, payload: value, id: applicationId };
}
export function updateCompanyChosenForPayment(value: ICompanyVm, applicationId: string) {
  return { type: UPDATE_COMPANY_CHOSEN_FOR_PAYMENT, payload: value, id: applicationId };
}
export function addNewCommentObjectToApplication(applicationId: string) {
  return (dispatch: Dispatch<any>) => {
    const user = UserHelper.currentUser();

    const newCommentObject = {
      ...ICommentVmInstance.empty(),
      id: Math.random().toString(),
      associatedEducationalInstitution: {
        ...IEducationalInstitutionVmInstance.empty(),
        id: user.type === UserType.EducationalWorker ? user.organization.id : "",
      },
      associatedIssuingAuthority: {
        ...IIssuingAuthorityVm.empty(),
        id: user.type === UserType.IssuingAuthorityCaseworker || user.type === UserType.IssuingAuthorityAdministrativeCaseWorker ? user.organization.id : "",
      },
    };

    dispatch({ type: ADD_COMMENT, payload: newCommentObject, id: applicationId });
  };
}
export function updateChosenApplicabilityType(value: ApplicabilityType, applicationId: string) {
  return { type: UPDATE_APPLICABILITY_TYPE, payload: value, id: applicationId };
}
export function updateAttendingSpecialCourse(value: AttendingSpecialCourseType, applicationId: string) {
  return { type: UPDATE_ATTENDING_SPECIAL_COURSE, payload: value, id: applicationId };
}
export function updatePreviousCertificateExpireDate(value: string, applicationId: string) {
  return { type: UPDATE_PREVIOUS_CERTIFICATE_EXPIRE_DATE, payload: value, id: applicationId };
}
export function updateHasPreviousCertificateExpireDate(value: boolean, applicationId: string) {
  return { type: UPDATE_HAS_PREVIOUS_APPLICATION_DATE, payload: value, id: applicationId };
}
export function updateIsContinuingEducationBasedOnNonBatApplication(value: boolean, applicationId: string) {
  return { type: UPDATE_IS_CONTINUING_EDUCATIOAN_BASED_ON_NON_BAT_APPLICATION, payload: value, id: applicationId };
}
export function updateSpecialConditionMet(value: boolean, applicationId: string) {
  return { type: UPDATE_SPECIAL_CONDITION_MET, payload: value, id: applicationId };
}
export function updateHealthConditionMet(value: boolean, applciationId: string) {
  return { type: UPDATE_HEALTH_CONDITION_MET, payload: value, id: applciationId };
}
